"use strict";
/**
 * Manage all the request and it is able to abort
 * all pending request.
 */

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

module.exports = /*#__PURE__*/function () {
  function RequestManager() {
    _classCallCheck(this, RequestManager);

    this.openedRequests = [];
  }

  _createClass(RequestManager, [{
    key: "add",
    value: function add(req) {
      this.openedRequests.push(req);
    }
  }, {
    key: "remove",
    value: function remove(req) {
      var idx = this.openedRequests.indexOf(req);

      if (idx !== -1) {
        this.openedRequests.splice(idx, 1);
      }
    }
  }, {
    key: "close",
    value: function close() {
      var _iterator = _createForOfIteratorHelper(this.openedRequests),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var openedRequest = _step.value;
          openedRequest.abort();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.openedRequests = [];
    }
  }, {
    key: "size",
    value: function size() {
      return this.openedRequests.length;
    }
  }]);

  return RequestManager;
}();